module.exports = __webpack_public_path__ + "static/img/01best.2d91486.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/theme/dark/sport/07sportIndex/01best.png
// module id = obPt
// module chunks = 0